<template>
    <div>
        <kgr-dropdown
            display="name"
            :label="label"
            :value="value"
            :options="availableDiscounts"
            :loading="loading"
            :inline="inline"
            @post-input="onInput($event)"
        />
    </div>
</template>

<script>
import ClubDiscount from '../../../../js/dto/ClubDiscount.js';
import ClubDiscountRepository from '../../../../js/repository/ClubDiscountRepository';
import Dropdown from './Dropdown.vue';

export default {
    components: {
        'kgr-dropdown': Dropdown,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        value: {
            type: ClubDiscount,
            default: () => null,
        },
        hideLabel: {
            type: Boolean,
            required: false,
            default: false,
        },
        inline: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            loading: true,
            discounts: [],
        };
    },
    computed: {
        label() {
            return this.hideLabel ? null : this.$t('clubDiscount');
        },
        availableDiscounts() {
            const discounts = this.discounts;
            const individualDiscount = new ClubDiscount();
            individualDiscount.id = ClubDiscount.INDIVIDUAL_DISCOUNT;
            individualDiscount.name = this.$t('Individueller Preis');
            discounts.push(individualDiscount);
            return discounts;
        },
    },
    created() {
        this.reload();
    },
    methods: {
        reload() {
            ClubDiscountRepository
                .findByClubId(this.clubId)
                .then((data) => {
                    this.loading = false;
                    this.discounts = data;
                })
                .catch(() => this.$notify.error('error.loadingData'));
        },
        onInput(value) {
            this.$emit('input', value);
            this.$nextTick(() => {
                this.$emit('post-input', value);
            });
        },
    },
};
</script>
